// ================================================================
//  <bm-date> — one shared calendar-icon + date renderer, for every
//  absolute timestamp reading in the app (created/updated/last login/
//  last sync/alert-since/...).
//
//  Consolidates what used to be a dozen independently-hand-rolled
//  `| date:'...'` filter calls with different format strings
//  ('dd/MM/yy HH:mm:ss', 'MM/dd/yyyy', 'yyyy-MM-dd hh:mm a', 'medium',
//  'short', ...) scattered across the app, plus a few custom JS
//  toLocaleDateString() formatters — now there is exactly one visual
//  shape (calendar icon + date) and a small, fixed set of canonical
//  formats, so dates read the same everywhere.
//
//  Usage:
//    <bm-date value="profile.createdTs"></bm-date>
//
//    <!-- Date only, no time (default is date + time). -->
//    <bm-date value="tmpl.createdTs" format="'MMM d, y'"></bm-date>
//
//    <!-- Compact — no padding/background, just icon + text, for a
//         tight table cell. -->
//    <bm-date value="c.createdTs" compact="true"></bm-date>
//
//  Bindings:
//    value   ('<') epoch millis, ISO string, or Date — or null/undefined,
//            which renders emptyText instead of an invalid date.
//    format  ('@') an Angular `date` filter format string. Defaults to
//            'MMM d, y, h:mm a' (canonical full date + time). Pass
//            'MMM d, y' for date-only, or 'MMM d, y, h:mm:ss a' when
//            second-level precision matters.
//    label   ('@') optional caption under the value ("Created",
//            "Last Login", ...) — ignored in compact mode.
//    variant ('@') 'neutral' (default) | 'success' | 'warning' | 'danger'.
//    compact   ('<') boolean — strips padding/background/border and the
//              label, for table cells and other tight spaces.
//    emptyText ('@') shown in place of the value when `value` is missing
//              — defaults to 'N/A'.
// ================================================================

angular.module('bizmetryApp').component('bmDate', {
  bindings: {
    value: '<',
    format: '@',
    label: '@',
    variant: '@',
    compact: '<',
    emptyText: '@'
  },
  template: `
    <span class="bm-date"
          ng-class="['bm-date--' + ($ctrl.variant || 'neutral'), $ctrl.compact ? 'bm-date--compact' : '']">
      <md-icon class="bm-date-icon">calendar_today</md-icon>
      <span class="bm-date-text">
        <span class="bm-date-value">{{ $ctrl.formatted() }}</span>
        <span class="bm-date-label" ng-if="$ctrl.label && !$ctrl.compact">{{ $ctrl.label }}</span>
      </span>
    </span>
  `,
  controller: function ($filter) {
    var vm = this;
    vm.formatted = function () {
      if (!vm.value) { return vm.emptyText || 'N/A'; }
      return $filter('date')(vm.value, vm.format || 'MMM d, y, h:mm a');
    };
  }
});
